var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-component"},[_c('ct-banner',{attrs:{"banner":_vm.banner}}),_c('ct-splash-content'),_c('ct-barcode-content'),_c('ct-service-content'),_c('ct-badges-content'),_c('ct-order-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }